import { Container, Title, Paper, Text, Select, Pagination, Flex } from '@mantine/core';
import { useState, useEffect } from 'react';
import PaymentHistory from '../components/profile/PaymentHistory';

const PaymentHistoryPage = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {
        // In a real application, you would fetch the total count from the API
        // and calculate total pages based on that
        setTotalPages(Math.ceil(100 / pageSize)); // Example with 100 total items
    }, [pageSize]);

    return (
        <Container size="lg" py="xl">
            <Title order={2} mb="xl">Payment History</Title>

            <Paper withBorder p="md" mb="xl">
                <Flex justify="flex-end" mb="md">
                    <Select
                        label="Items per page"
                        value={pageSize.toString()}
                        onChange={(value) => {
                            setPageSize(Number(value));
                            setCurrentPage(1); // Reset to first page when changing page size
                        }}
                        data={['5', '10', '20', '50'].map(size => ({ value: size, label: size }))}
                        w={100}
                    />
                </Flex>

                <PaymentHistory
                    fetchData
                    showViewAll={false}
                />

                <Flex justify="flex-end" mt="xl">
                    <Pagination
                        total={totalPages}
                        value={currentPage}
                        onChange={setCurrentPage}
                    />
                </Flex>
            </Paper>

            <Text size="sm" color="dimmed" ta="center">
                For questions about your payments, please contact customer support.
            </Text>
        </Container>
    );
};

export default PaymentHistoryPage;
